module.exports = __webpack_public_path__ + "static/media/star-ball_03.15670d98.png";